import React from 'react';
import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import styled, { createGlobalStyle } from 'styled-components';
import './App.css';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html, body, #root {
    height: 100%;
    width: 100%;
    font-family: 'SpaceMono', monospace;
    background: #000;
    color: #fff;
    overflow-x: hidden;
  }
  
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  * {
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  }
  
  *::-webkit-scrollbar {
    width: 6px;
  }
  
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  
  *::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }
  
  *::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const LoadingScreen = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  font-weight: 500;
`;

const AppContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  background: #000;
`;

const Home = lazy(() => import('./Pages/Home.js'));
const Privacy = lazy(() => import('./Pages/Privacy.js'));
const Terms = lazy(() => import('./Pages/Terms.js'));
const About = lazy(() => import('./Pages/About.js'));
const SystemRequirements = lazy(() => import('./Pages/SystemRequirements.js'));

const App = () => {
    return (
        <>
            <GlobalStyle />
            <Suspense fallback={<LoadingScreen>Loading SafeNotes...</LoadingScreen>}>
                <Router>
                    <AppContainer>
                        <Switch>
                            <Route exact path="/" component={Home} />
                            <Route path="/privacy" component={Privacy} />
                            <Route path="/terms" component={Terms} />
                            <Route path="/about" component={About} />
                            <Route path="/system-requirements" component={SystemRequirements} />
                        </Switch>
                    </AppContainer>
                </Router>
            </Suspense>
        </>
    );
}

export default App;
